import Cookies from 'js-cookie';

const deleteCookie = (name) => {
  Cookies.remove(name, { path: '/' });
};

const clearSessionAndCookieItem = (key) => {
    sessionStorage.removeItem(key);
    deleteCookie(key);
}

export default clearSessionAndCookieItem;